import {
  STANDALONE_DISABLED_ELEMENTS,
  UNIVERSALLY_DISABLED_ELEMENTS,
} from './data/constants';

export const DEFAULT_VIEWER_CONFIG: ViewerConfig = {
  pdftron: {
    disabledElements: UNIVERSALLY_DISABLED_ELEMENTS,
  },
  extractionsEnabled: false,
  tableExtractionsEnabled: false,
  readOnlyAnnotationImport: false,
  canDownloadPdf: false,
};

export type ViewerConfig = {
  pdftron: {
    disabledElements: readonly string[];
    initialToolbarGroup?: 'View' | 'Annotate';
  };
  // Service-level capabilities
  extractionsEnabled: boolean;
  tableExtractionsEnabled: boolean;
  readOnlyAnnotationImport: boolean;
  canDownloadPdf: boolean;
};

type StandaloneViewerConfigFlags = {
  canDownloadPdf: boolean;
};

export const buildStandaloneViewerConfig = (
  flags: StandaloneViewerConfigFlags,
): ViewerConfig => ({
  pdftron: {
    disabledElements: [
      ...UNIVERSALLY_DISABLED_ELEMENTS,
      ...STANDALONE_DISABLED_ELEMENTS,
    ],
    initialToolbarGroup: 'View',
  },
  extractionsEnabled: false,
  tableExtractionsEnabled: true,
  readOnlyAnnotationImport: false,
  canDownloadPdf: flags.canDownloadPdf,
});

type PartLibraryConfigFlags = {
  isPdfRedactionEnabled: boolean;
  canDownloadPdf: boolean;
};

export const buildPartLibraryConfig = (
  flags: PartLibraryConfigFlags,
): ViewerConfig => ({
  pdftron: {
    disabledElements: [
      ...UNIVERSALLY_DISABLED_ELEMENTS,
      ...(flags.isPdfRedactionEnabled ? [] : ['toolbarGroup-Redact']),
    ],
  },
  extractionsEnabled: false,
  tableExtractionsEnabled: false,
  readOnlyAnnotationImport: true,
  canDownloadPdf: flags.canDownloadPdf,
});

type QuotePartViewerConfigFlags = {
  isReqsReviewEnabled: boolean;
  isPdfRedactionEnabled: boolean;
  isBeamsEnabled: boolean;
  isRunesEnabled: boolean;
  canDownloadPdf: boolean;
};

export const buildQuotePartViewerConfig = (
  flags: QuotePartViewerConfigFlags,
): ViewerConfig => ({
  pdftron: {
    disabledElements: [
      ...UNIVERSALLY_DISABLED_ELEMENTS,
      ...(flags.isPdfRedactionEnabled ? [] : ['toolbarGroup-Redact']),
    ],
  },
  extractionsEnabled: flags.isRunesEnabled,
  tableExtractionsEnabled: flags.isBeamsEnabled,
  readOnlyAnnotationImport: true,
  canDownloadPdf: flags.canDownloadPdf,
});
